import { render, staticRenderFns } from "./workArea.vue?vue&type=template&id=2ee7bbbc&scoped=true&"
import script from "./workArea.vue?vue&type=script&lang=js&"
export * from "./workArea.vue?vue&type=script&lang=js&"
import style0 from "./workArea.vue?vue&type=style&index=0&id=2ee7bbbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7bbbc",
  null
  
)

export default component.exports